import React from 'react';
import { Chart } from 'react-google-charts';
import WrapperCard from './WrapperCard';

const LINE_TYPES = {
  VOICE: 'voice',
  ALARM: 'alarm',
  FORWARD: 'forward',
  RINGDOWN: 'ringDown',
  HUNT: 'hunt',
  FAXSTANDARD: 'faxStandard',
  ELEVATOR: 'elevator',
  MODEM: 'modem',
  PRI: 'pri',
  FAX: 'fax',
  FIREALARM: 'fireAlarm',
  SECUREENTRY: 'secureEntry',
};

const options = {
  legend: { position: 'bottom', alignment: 'start'},
  chartArea: {
    left: 50,
    right: 15,
    top: 5,
    bottom: 40,
  },
  series: {
    0: { color: '#03045e' }, 
    1: { color: '#023e8a' },
    2: { color: '#0077b6' },
    3: { color: '#0096c7' }, 
    4: { color: '#00b4d8' }, 
    5: { color: '#c5e5eb' }, 
    6: { color: '#caf0f8' }, 
    7: { color: '#1c6d7d' }, 
    8: { color: '#2c6c79' },
    10: { color: '#164177' },
    11: { color: '#0082b8' },
    12: { color: '#00a0d0' },
    13: { color: '#00bde8' },
    14: { color: '#165f6e' },
    15: { color: '#237682' }
  },
  pointsVisible: true,
  lineWidth: 2,
  hAxis: {
    minorGridlines: { count: 0 }
  },
  vAxis: {
    format: 'short',
  }
};

function UsageByLineType({ isLoading, data }) {
  const buckets = data?.line_over_time || [];

  const chartData = React.useMemo(() => {
    if (!buckets?.length) {
      return [];
    }

    return buckets.reduce(
      (acc, item) => {
        const {
          key_as_string: dayKey,
          line_types: { buckets: lineTypes },
        } = item;

        const arr = [{ v: dayKey, f: dayKey }];
        for (const i of acc[0]) {
          const lineType = lineTypes.find(b => b.key === i);
          const doc_count = lineType?.doc_count;
          if (i === 'Date') {
            continue;
          }

          if (doc_count) {
            arr.push(doc_count);
          } else {
            arr.push(0);
          }
        }

        acc.push(arr);
        return acc;
      },
      [
        [
          'Date',
          LINE_TYPES.VOICE,
          LINE_TYPES.ALARM,
          LINE_TYPES.FORWARD,
          LINE_TYPES.RINGDOWN,
          LINE_TYPES.HUNT,
          LINE_TYPES.FAXSTANDARD,
          LINE_TYPES.ELEVATOR,
          LINE_TYPES.MODEM,
          LINE_TYPES.PRI,
          LINE_TYPES.FIREALARM,
          LINE_TYPES.SECUREENTRY,
          LINE_TYPES.FAX,
        ],
      ],
    );
  }, [buckets]);

  return (
    <WrapperCard
      isLoading={isLoading}
      title="7 Day Usage by Line Type (# of calls)"
      contentSkeletons={7}
      headerTooltip="Number of calls per line type across all assigned EPIK Edge Devices for the last 7 days"
    >
    {chartData?.length ? (
        <Chart chartType="LineChart" width="100%" height="220px" data={chartData} options={options} />
      ) : (
        <div style={{ textAlign: 'center', padding: '20px' }}>No data available</div>
    )}
    </WrapperCard>
  );
}

export default UsageByLineType;
